import { Box, Flex, Text, Link, Center, Spinner, } from '@chakra-ui/react';
import { Link as RouterLink } from "react-router-dom";
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, } from 'chart.js';
import MyDiv from './employeeChartCart.style';
import { useEffect, useState } from 'react';
import { CustomToast } from '../../../../components';
import { useFetch } from '../../../../hooks/useFetch';

ChartJS.register(ArcElement, Tooltip, Legend);

const chartColors = [
  '#E6194B', // Red
  '#3CB44B', // Green
  '#FFE119', // Yellow
  '#4363D8', // Blue
  '#F58231', // Orange
  '#911EB4', // Purple
  '#46F0F0', // Cyan
  '#F032E6', // Magenta
  '#BCF60C', // Lime
  '#FABEBE', // Light Pink
  '#008080', // Teal
  '#E6BEFF', // Lavender
  '#9A6324', // Brown
];

const EmployeeChartCard = ({ branch }: { branch: number[] }) => {
    const [labels, setLabels] = useState<string[]>([]);
    const [counts, setCounts] = useState<number[]>([]);
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);

    const loadDepartmentData = async () => {
        const params = new URLSearchParams();

        if (branch && branch.length > 0) {
            branch.forEach((b) => params.append("branch", b.toString()));
        } else {
            params.append("branch", "0");
        }
        const response = await fetchApi<any[]>('Dashboard/EmployeeCount', 'GET', null, params.toString());

        if (Array.isArray(response)) {
            const deptNames = response.map(item => item.departmentName);
            const empCounts = response.map(item => item.employeeCount);

            setLabels(deptNames);
            setCounts(empCounts);
        } else {
            setLabels([]);
            setCounts([]);
        }
    };

    useEffect(() => {
        loadDepartmentData();
    }, [branch]);

    const data = {
        labels: labels,
        datasets: [
            {
                data: counts,
                backgroundColor: chartColors.slice(0, labels.length),
                borderWidth: 0,
                cutout: '70%',
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                display: false,
            },
        },
        responsive: true,
        maintainAspectRatio: false,
    };

    return (
        <MyDiv>
            <Flex justify="space-between" align="center" mb={3}>
                <Text className='font-poppins text_md text_medium'>Employees</Text>
                <Link className='font-poppins text_sm text_medium' color="blue.500" as={RouterLink} to="/employees">View details</Link>
            </Flex>
            <Box className="chart-container" p={4} bg="white" rounded="xl" boxShadow="md">
                <Flex justify="center" align="center">
                    <Box className="donut-chart">
                        <Doughnut data={data} options={options} />
                    </Box>
                </Flex>
                <Box className="legend-list">
                    <Box position="relative" minH="300px" pl={10}>
                        {loading ? (
                            <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                            </Center>) : (
                            <>
                                {labels.map((label, i) => (
                                    <Flex className="legend-row" key={i} align="center" justify="space-between">
                                        <Flex align="center">
                                            <Box className="color-box" bg={chartColors[i % chartColors.length]} />
                                            <Text className='font-poppins text_sm text_medium' ml={2}>{label}</Text>
                                        </Flex>
                                        <Text className='font-poppins text_sm text_medium' fontWeight="medium">{counts[i]}</Text>
                                    </Flex>
                                ))}
                            </>)}
                    </Box>
                </Box>
            </Box>
        </MyDiv>
    );
};

export default EmployeeChartCard;
